<template>
  <svg height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
    <rect fill="currentColor" height="14" rx="2" ry="2" width="22" x="1" y="5"/>
    <circle cx="12" cy="12" fill="#ffffff" r="4"/>
    <rect fill="none" height="12" rx="1" ry="1" stroke="#ffffff" stroke-width="0.5" width="20" x="2" y="6"/>
  </svg>
</template>